import {Caller} from "../../core/Caller";

export class ReviewsCore {

    constructor({ url }) {
        this.caller = new Caller({ baseUrl: `${url}/reviews` })
    }

    async getView(params) {
        return await this.caller.call({ action: 'getView', ...params })
    }

    async getPage(params) {
        return await this.caller.call({ action: 'getPage', ...params })
    }
}